var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.fields && _vm.fields.length > 0)?_c('Form',{model:{value:(_vm.fields),callback:function ($$v) {_vm.fields=$$v},expression:"fields"}}):_vm._e(),_c('b-btn',{staticClass:"background-blue float-right",attrs:{"size":"sm","squared":""},on:{"click":_vm.viewChart}},[_vm._v(" View Chart ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }